import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import theme, { textBold } from 'theme/theme';

const Button = styled.a.attrs(() => ({ className: 'button' }))`
  display: ${(props) => (props.isFullWidth ? 'block' : 'inline-block')};
  width: auto;
  padding: 10px 20px;
  border: 1px solid transparent;
  border-radius: 0;
  background: transparent;
  font-size: ${theme.fontSizes.default};
  color: inherit;
  text-decoration: none;
  text-align: center;
  transition: all 0.2s;
  &:hover {
    cursor: pointer;
    color: ${theme.colors.primary};
    svg {
      fill: ${theme.colors.primary};
    }
  }
  
  svg {
    opacity: 0.9;
  }
  
  ${(props) => props.variant === 'primary' && css`
    &,&:hover {
      background: ${theme.colors.primary};
      border-color: ${theme.colors.primary};
      color: #fff;
      ${textBold};
    }
    ${!props.disabled && css`
      &:hover {
        background: transparent;
        color: ${theme.colors.primary};
        border-color: ${theme.colors.primary};
        svg {
          fill: ${theme.colors.white};
        }
      }
    `}
  `}
  
  ${(props) => props.variant === 'secondary' && css`
    &,&:hover {
      background: transparent;
      border-color: ${theme.colors.medium};
      color: ${theme.colors.medium};
      ${textBold};
    }
    ${!props.disabled && css`
      &:hover {
        background: transparent;
        color: ${theme.colors.primary};
        border-color: ${theme.colors.primary};
      }
    `}
  `}
  
  ${(props) => props.variant === 'light' && css`
    &,&:hover {
      color: ${theme.colors.light};
    }
    ${!props.disabled && css`
      &:hover {
        color: ${theme.colors.white};
        svg {
          fill: ${theme.colors.white};
        }
      }
    `}
  `}
  
  
  ${(props) => props.variant === 'white' && css`
    &,&:hover {
      color: ${theme.colors.dark};
      background: ${theme.colors.white};
    }
  `}
  
  ${(props) => props.variant === 'negative' && css`
    &,&:hover {
      color: ${theme.colors.white};
    }
    ${!props.disabled && css`
      &:hover {
        color: ${theme.colors.primary};
        svg {
          fill: ${theme.colors.primary};
        }
      }
    `}
  `}
  
  ${(props) => props.disabled && css` 
    opacity: 0.5;
    &:hover {
      cursor: not-allowed;
    }
  `}
  
    
  ${(props) => props.isFullWidth && css`
    width: 100%;
  `}
`;
Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'light', 'white', 'negative', 'ghost']),
  isFullWidth: PropTypes.bool,
};
Button.defaultProps = {
  isFullWidth: false,
  variant: 'ghost',
};

export default Button;
